import { render, staticRenderFns } from "./complainIndex.vue?vue&type=template&id=ca857930&scoped=true&"
import script from "./complainIndex.vue?vue&type=script&lang=js&"
export * from "./complainIndex.vue?vue&type=script&lang=js&"
import style0 from "./complainIndex.vue?vue&type=style&index=0&id=ca857930&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca857930",
  null
  
)

export default component.exports